import React from 'react';

const TRACKS = [
  {
    title: 'COMMAND OPERATIONS',
    desc: 'Operating the NWG Command Center — vault discipline, module workflows, and secure access practices.',
  },
  {
    title: 'WEALTH STEWARDSHIP',
    desc: 'Legacy preservation fundamentals — family governance, documentation, and generational planning.',
  },
  {
    title: 'GROWTH SYSTEMS',
    desc: 'Funnels, analytics, and capital intelligence — turning insight into executed strategy.',
  },
];

export default function EducationCenter() {
  return (
    <div style={styles.wrap} data-testid="education-center-panel">
      <p style={styles.lead}>
        A private curriculum built on the NextWealth™ Global method:
        Show Us the Problems. We Build the Solutions.
      </p>
      <div style={styles.grid}>
        {TRACKS.map(t => (
          <div key={t.title} style={styles.card} data-testid={`education-track-${t.title.toLowerCase().replace(/ /g, '-')}`}>
            <div style={styles.cardTitle}>{t.title}</div>
            <div style={styles.cardDesc}>{t.desc}</div>
            <div style={styles.badge}>LAUNCH COHORT — ENROLLMENT OPENS SOON</div>
          </div>
        ))}
      </div>
      <p style={styles.note}>
        Course materials are released to members first. Your access level determines available tracks.
      </p>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  wrap: { width: '100%', maxWidth: 900, margin: '0 auto', padding: '24px 20px', overflowY: 'auto' },
  lead: { color: '#FFD700', fontSize: 15, opacity: 0.85, letterSpacing: 0.5, margin: '0 0 24px', lineHeight: 1.6 },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16 },
  card: {
    border: '1px solid rgba(255, 215, 0, 0.35)', borderRadius: 8, padding: '18px 16px',
    background: 'rgba(255, 215, 0, 0.04)', textAlign: 'left',
  },
  cardTitle: { color: '#FFD700', fontSize: 14, fontWeight: 'bold', letterSpacing: 1, marginBottom: 10 },
  cardDesc: { color: '#bbb', fontSize: 13, lineHeight: 1.6, marginBottom: 14 },
  badge: {
    display: 'inline-block', fontSize: 10, letterSpacing: 1, color: '#FFD700',
    border: '1px solid rgba(255, 215, 0, 0.4)', borderRadius: 4, padding: '4px 8px', opacity: 0.8,
  },
  note: { color: '#777', fontSize: 12, marginTop: 24, lineHeight: 1.6 },
};
